export default __webpack_public_path__ + "static/MD_SearchThumb_Cloud_Create-606badfc2bc45ed0e2799ce7bf94fe7b.webp";